export const NAMESPACE = "AddAssignmentModal";

export const DROPDOWN_FIELD_ID = "addAssignmentModalTypes";

export const TYPES = {
  ACCOUNT: "account",
  CONTACT: "contact"
};
